import React from "react";

const Pill = ({ tone = "gray", children, className = "", ...rest }) => (
  <span className={`pill pill--${tone}${className ? " " + className : ""}`} {...rest}>
    {children}
  </span>
);

export default Pill;
